<template>
  <div class="wrapper d-flex align-center justify-center">
    <v-card class="login-card pa-6" elevation="6">
      <v-card-title class="justify-center mb-4">
        <img src="/img/logo.png" width="100" />
      </v-card-title>

      <div class="text-center">
        <h1 class="text-h4 font-weight-bold mb-2">404</h1>
        <h2 class="text-h5 font-weight-bold mb-2">Página Não Encontrada</h2>
        <p class="text-subtitle-1 mb-6">
          Desculpe, a página que você está procurando não existe ou foi removida.
        </p>

        <v-btn color="primary" @click="$router.push({ name: 'home' })" rounded large>
          Voltar para o Início
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style scoped>
.wrapper {
  height: 100vh;
  width: 100vw;
  background-image: url("../assets/background.png");
  background-size: cover;
  background-position: center;
}

.login-card {
  width: 90vw;
  max-width: 500px;
  background-color: rgba(255, 255, 255, 0.85);
  border-radius: 16px;
}
</style>
